module.exports = __webpack_public_path__ + "static/media/thumbnail.848e319e.jpg";